import { render, staticRenderFns } from "./YearStatistics.vue?vue&type=template&id=2d621c49&scoped=true&"
import script from "./YearStatistics.vue?vue&type=script&lang=js&"
export * from "./YearStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d621c49",
  null
  
)

export default component.exports